export const routes = {
  ru: "/ru",
  en: "/en",
  pt: "/pt",
  test: "/test",
  questionnaire: "/questionnaire",
  report: (token: string) => `/report/${token}`,
  assetReport: "/landing-assets/report",
  assetQuestionnaire: "/landing-assets/questionnaire",
  assetTestForm: "/landing-assets/test-form",
} as const;
